/* any functionality that's shared between component variants but not needed by external components goes in this file */
export function useTabBehavior(id, activeTabIndex, onChangeIndex, tabs, orientation) {
  var onTabClick = function onTabClick(e) {
    e.preventDefault();
    var targetLink; // the event target will either be the link we want or its descendant

    if (e.target.tagName !== 'A') {
      targetLink = e.target.closest('a');
    } else {
      targetLink = e.target;
    }

    var selectedIndex = Number(targetLink.getAttribute('data-index'));

    if (selectedIndex !== activeTabIndex) {
      onChangeIndex(selectedIndex);
    }
  };

  var onTabKeyDown = function onTabKeyDown(e) {
    var selectedIndex = Number(e.target.getAttribute('data-index'));
    var key = e.key;
    var DecreaseIndex = orientation === 'vertical' ? key === 'ArrowUp' || key === 'Up' : key === 'ArrowLeft' || key === 'Left';
    var IncreaseIndex = orientation === 'vertical' ? key === 'ArrowDown' || key === 'Down' : key === 'ArrowRight' || key === 'Right';

    if (DecreaseIndex) {
      e.preventDefault();

      var _newIndex;

      if (selectedIndex > 0) {
        _newIndex = selectedIndex - 1;
      } else {
        return;
      }

      onChangeIndex(_newIndex);
      var newFocusedHeader = document.getElementById("".concat(id, "_tabheader_").concat(_newIndex)); // there's no real way for the else case to happen

      /* istanbul ignore else */

      if (newFocusedHeader) newFocusedHeader.focus({
        preventScroll: orientation === 'horizontal' ? true : undefined
      }); // if (newFocusedHeader) newFocusedHeader.focus();
    } else if (IncreaseIndex) {
      e.preventDefault();

      var _newIndex2;

      if (selectedIndex < tabs.length - 1) {
        _newIndex2 = selectedIndex + 1;
      } else {
        return;
      }

      onChangeIndex(_newIndex2);

      var _newFocusedHeader = document.getElementById("".concat(id, "_tabheader_").concat(_newIndex2));

      _newFocusedHeader && _newFocusedHeader.focus({
        preventScroll: orientation === 'horizontal' ? true : undefined
      }); // newFocusedHeader && newFocusedHeader.focus();
    }
  };

  return {
    onTabKeyDown: onTabKeyDown,
    onTabClick: onTabClick
  };
}
export var transformDeprecatedSizeValues = function transformDeprecatedSizeValues(size) {
  switch (size) {
    case 'large':
      return 'lg';

    case 'small':
      return 'sm';

    default:
      return size;
  }
};